/**
 * Beat the Price Rise — collection/product card links and collection
 * banner click-to-open popup. Config via `window.beatPriceRiseData`.
 */
(function () {
  function initBeatPriceRiseLinks() {
    if (document.body.classList.contains('template-collection')) return;

    var data = window.beatPriceRiseData;
    if (!data || !data.byHandle) return;

    document.querySelectorAll('.beat-price-rise-link-container').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;

      var handle = container.dataset.productHandle;
      if (!handle) {
        var cardWrapper = container.closest('.card-wrapper');
        if (cardWrapper) {
          handle = cardWrapper.dataset.productHandle;
        }
      }

      if (handle && data.byHandle[handle]) {
        var popupId = 'beat-price-rise-popup-' + data.byHandle[handle];
        container.className = container.className + ' dy:text-left';
        container.innerHTML =
          '<span class="dy:inline-block dy:mt-1.5"><button type="button" class="beat-price-rise-trigger dy:flex dy:flex-col dy:items-start  dy:gap-1 dy:px-1.5 dy:py-0.5 dy:text-[11px] dy:cursor-pointer dy:transition-all dy:duration-200" data-popup-id="' +
          popupId +
          '" aria-haspopup="dialog"><span class="dy:text-[#5482c7] dy:font-medium">Beat the price rise!</span> <span class="dy:text-[#5482c7] dy:underline dy:font-normal">Learn More</span></button></span>';
        container.dataset.initialized = 'true';
      }
    });
  }

  window.addEventListener('globoFilterRenderCompleted', function () {
    setTimeout(initBeatPriceRiseLinks, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('template-collection')) return;

    var collectionHandle = '';
    var collectionMatch = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
    if (collectionMatch) {
      collectionHandle = collectionMatch[1];
    }

    var popups = document.querySelectorAll('[id^="beat-price-rise-popup-"]');
    if (popups.length === 0) return;

    var popup = popups[0];

    function openBeatPriceRisePopup() {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = popup.querySelector('.beat-price-rise-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    function shouldOpenPopupFromUrl(url) {
      if (!url) return false;
      try {
        var urlObj = new URL(url, window.location.origin);
        var urlParams = new URLSearchParams(urlObj.search);
        var hash = urlObj.hash;
        return urlParams.get('show-beat-the-price') === 'true' || hash === '#show-beat-the-price';
      } catch (e) {
        var urlParams = new URLSearchParams(url.split('?')[1] || '');
        var hashMatch = url.match(/#show-beat-the-price/);
        return urlParams.get('show-beat-the-price') === 'true' || hashMatch !== null;
      }
    }

    if (shouldOpenPopupFromUrl(window.location.href)) {
      setTimeout(openBeatPriceRisePopup, 300);
    }

    window.addEventListener('hashchange', function () {
      if (shouldOpenPopupFromUrl(window.location.href)) {
        setTimeout(openBeatPriceRisePopup, 100);
      }
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || !link.href) return;

      if (link.href.includes('/collections/') && shouldOpenPopupFromUrl(link.href)) {
        if (link.href.split('#')[0] === window.location.href.split('#')[0]) {
          return;
        }
      }
    });

    if (collectionHandle === 'office-pods-meeting-booths' || collectionHandle === 'almost-perfect') {
      return;
    }

    var bannerImg = document.querySelector('.top-banner-img');
    if (bannerImg) {
      bannerImg.style.cursor = 'pointer';
      bannerImg.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openBeatPriceRisePopup();
      });
    }
  });
})();
